import { API } from "utils";

export const getFieldsApi = async (params) => {
  const response = await API().get("fields", {
    params,
  });
  return response.data;
};
